import React from "react";
import StripeCheckout from "react-stripe-checkout";
import { Button } from "semantic-ui-react";
import { graphql, gql } from "react-apollo";
import { connect } from "react-redux";
import { navigateTo } from "gatsby-link";
import moment from "moment";
import PRBContainer from "./PRBContainer";
import { cleaningScheduled } from "../../../actions/CleaningActions";

class TakeMoney extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  onToken = token => {
    // fetch("/save-stripe-token", {
    //   method: "POST",
    //   body: JSON.stringify(token)
    // }).then(response => {
    //   console.log(response);
    //   response.json().then(data => {
    //     alert(`We are in business, ${data.email}`);
    //   });
    // });
    this.setState({ loading: true });
    const { card } = token;
    this.props.user
      ? this.props
          .newJob({
            variables: {
              id: this.props.user.id,
              // address: `${card.address_line1} ${card.address_line2}`,
              // city: card.address_city,
              // firstName: this.props.firstName,
              // lastName: this.props.lastName,
              // phone: this.props.phone,
              // zip: card.address_zip,
              jobAddress: this.props.address, //add suite number at some point
              jobCity: this.props.city,
              bathrooms: this.props.numBathrooms,
              frequency: this.props.frequency,
              bedrooms: this.props.numBedrooms,
              price: this.props.price / 100,
              // price: 123,
              time: `${moment(this.props.selectedDate).format(
                "YYYY-MM-DD"
              )}T${this.props.selectedTime}`,
              jobZip: this.props.zip,
              cardToken: token.id,
              email: this.props.email
            }
          })
          .then(data => {
            console.log("...booking success");
            this.setState({ loading: false });
            this.props.cleaningScheduled({
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,

              discount: 0,
              date: moment(
                `${moment(this.props.selectedDate).format("YYYY-MM-DD")}T${this
                  .props.selectedTime}`
              ),
              time: this.props.selectedTime
            });
            navigateTo("/congrats");
          })
          .catch(err => console.error(err))
      : this.props
          .newUser({
            variables: {
              address: `${card.address_line1}`,
              city: card.address_city,
              firstName: this.props.firstName,
              lastName: this.props.lastName,
              phone: this.props.phone,
              zip: card.address_zip,
              jobAddress: this.props.address, //add suite number at some point
              jobCity: this.props.city,
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,
              // price: this.props.price / 100,
              price: 123,
              time: `${moment(this.props.selectedDate).format(
                "YYYY-MM-DD"
              )}T${this.props.selectedTime}Z`,
              jobZip: this.props.zip,
              cardToken: token.id,
              email: this.props.email,
              password: this.props.password
            }
          })
          .then(data => {
            console.log("...booking success");
            if (data && data.data.signupUser) {
              console.log("setting user...");
              localStorage.setItem("gToken", data.data.signupUser.token);
            }
            this.props.cleaningScheduled({
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,

              discount: 0,
              date: moment(
                `${moment(this.props.selectedDate).format("YYYY-MM-DD")}T${this
                  .props.selectedTime}`
              ),
              time: this.props.selectedTime
            });
            navigateTo("/congrats");
          })
          .catch(err => console.error(err));
  };

  // ...

  render() {
    const {
      frequency,
      numBedrooms,
      numBathrooms,
      discountCode,
      price
    } = this.props;

    return (
      // ...
      <div>
        <StripeCheckout
          token={this.onToken}
          stripeKey="pk_test_uNWjlfbUWZxMqNTgejG8ixkh"
          zipCode={true}
          billingAddress={true}
          name="Maid To Clean Jax"
          amount={price}
          email={this.props.email}
        >
          <Button size="huge" loading={this.state.loading} fluid color="green">
            Book Now
          </Button>
        </StripeCheckout>
        {/* <PRBContainer
          onToken={this.onToken.bind(this)}
          total={{ label: "Maid To Clean Jax", amount: price }}
          style={{ marginTop: "50px" }}
        /> */}
      </div>
    );
  }
}
const myMutation = gql`
  mutation CreateUser(
    $address: String!
    $city: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $zip: String!
    $email: String!
    $password: String!
    $bedrooms: Int!
    $bathrooms: Int!
    $frequency: String!
    $jobAddress: String!
    $jobCity: String!
    $price: Float!
    $time: DateTime!
    $jobZip: String!
    $cardToken: String!
  ) {
    signupUser(
      address: $address
      city: $city
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      zip: $zip
      email: $email
      password: $password
      jobAddress: $jobAddress
      jobCity: $jobCity
      price: $price
      frequency: $frequency
      bedrooms: $bedrooms
      bathrooms: $bathrooms
      time: $time
      jobZip: $jobZip
      cardToken: $cardToken
    ) {
      id
      token
    }
  }
`;
const updateMutation = gql`
  mutation createJob(
    $id: ID!
    $jobAddress: String!
    $jobCity: String!
    $price: Float!
    $time: DateTime!
    $jobZip: String!
    $cardToken: String!
    $bathrooms: Int!
    $bedrooms: Int!
    $frequency: String!
  ) {
    createJob(
      address: $jobAddress
      city: $jobCity
      price: $price
      bathrooms: $bathrooms
      bedrooms: $bedrooms
      time: $time
      frequency: $frequency
      userId: $id
      zip: $jobZip
      cardDetails: { cardToken: $cardToken }
    ) {
      id
      address
      city
      price
      bathrooms
      bedrooms
      time
      frequency
    }
  }
`;
// const Selector = formValueSelector("contact");
// TakeMoney = connect(state =>
//   Selector(
//     state,
//     "firstName",
//     "lastName",
//     "email",
//     "phone",
//     "password",
//     "address",
//     "aptNumber",
//     "city",
//     "zip",
//     "numBedrooms",
//     "numBathrooms",
//     "discountCode",
//     "selectedDate",
//     "selectedTime",
//     "frequency"
//   )
// )(TakeMoney);
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cleaningScheduled: cleaning => {
      dispatch(cleaningScheduled(cleaning));
    }
  };
};
TakeMoney = graphql(updateMutation, { name: "newJob" })(
  graphql(myMutation, { name: "newUser" })(TakeMoney)
);
export default connect(null, mapDispatchToProps)(TakeMoney);



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/PaymentButton.jsx